import { GradientsValues } from '../../gradients/gradients/index.js';
import { ShadowLightValues, ShadowDarkValues } from '../../shadows/shadows/index.js';
import { NeutralColorsLightValues, NeutralColorsDarkValues } from '../../neutralColors/neutralColors/index.js';
import { WarningColorsLightValues, WarningColorsDarkValues } from '../../warningColors/warningColors/index.js';
import { TransformerColorsLightValues, TransformerColorsDarkValues } from '../../transformerColors/transformerColors/index.js';
import { TextColorsLightValues, TextColorsDarkValues } from '../../textColors/textColors/index.js';
import { SuccessColorsLightValues, SuccessColorsDarkValues } from '../../successColors/successColors/index.js';
import { SnapchatColorsLightValues, SnapchatColorsDarkValues } from '../../snapchatColors/snapchatColors/index.js';
import { SecondaryColorsLightValues, SecondaryColorsDarkValues } from '../../secondaryColors/secondaryColors/index.js';
import { PrimaryColorsLightValues, PrimaryColorsDarkValues } from '../../primaryColors/primaryColors/index.js';
import { PremiumColorsLightValues, PremiumColorsDarkValues } from '../../premiumColors/premiumColors/index.js';
import { PositiveColorsLightValues, PositiveColorsDarkValues } from '../../positiveColors/positiveColors/index.js';
import { NegativeColorsLightValues, NegativeColorsDarkValues } from '../../negativeColors/negativeColors/index.js';
import { LineColorsLightValues, LineColorsDarkValues } from '../../lineColors/lineColors/index.js';
import { KakaoColorsLightValues, KakaoColorsDarkValues } from '../../kakaoColors/kakaoColors/index.js';
import { InformationColorsLightValues, InformationColorsDarkValues } from '../../informationColors/informationColors/index.js';
import { GoogleColorsLightValues, GoogleColorsDarkValues } from '../../googleColors/googleColors/index.js';
import { FacebookColorsLightValues, FacebookColorsDarkValues } from '../../facebookColors/facebookColors/index.js';
import { ErrorColorsLightValues, ErrorColorsDarkValues } from '../../errorColors/errorColors/index.js';
import { ControlValueColorsLightValues, ControlValueColorsDarkValues } from '../../controlValueColors/controlValueColors/index.js';
import { ControlTextColorsLightValues, ControlTextColorsDarkValues } from '../../controlTextColors/controlTextColors/index.js';
import { ControlStartIconColorsLightValues, ControlStartIconColorsDarkValues } from '../../controlStartIconColors/controlStartIconColors/index.js';
import { ControlSliderTrackColorsLightValues, ControlSliderTrackColorsDarkValues } from '../../controlSliderTrackColors/controlSliderTrackColors/index.js';
import { ControlSliderThumbColorsLightValues, ControlSliderThumbColorsDarkValues } from '../../controlSliderThumbColors/controlSliderThumbColors/index.js';
import { ControlPlaceholderColorsLightValues, ControlPlaceholderColorsDarkValues } from '../../controlPlaceholderColors/controlPlaceholderColors/index.js';
import { ControlEndIconColorsLightValues, ControlEndIconColorsDarkValues } from '../../controlEndIconColors/controlEndIconColors/index.js';
import { ControlCaretColorsLightValues, ControlCaretColorsDarkValues } from '../../controlCaretColors/controlCaretColors/index.js';
import { ControlBorderColorsLightValues, ControlBorderColorsDarkValues } from '../../controlBorderColors/controlBorderColors/index.js';
import { ControlBackgroundColorsLightValues, ControlBackgroundColorsDarkValues } from '../../controlBackgroundColors/controlBackgroundColors/index.js';
import { BackgroundColorsLightValues, BackgroundColorsDarkValues } from '../../backgroundColors/backgroundColors/index.js';
import { AppleColorsLightValues, AppleColorsDarkValues } from '../../appleColors/appleColors/index.js';
import { AbsolutesWhiteColorsLightValues, AbsolutesWhiteColorsDarkValues } from '../../absolutesWhiteColors/absolutesWhiteColors/index.js';
import { AbsolutesBlackColorsLightValues, AbsolutesBlackColorsDarkValues } from '../../absolutesBlackColors/absolutesBlackColors/index.js';

const ThemeLightValues = Object.freeze({
    absolutesBlackColors: AbsolutesBlackColorsLightValues,
    absolutesWhiteColors: AbsolutesWhiteColorsLightValues,
    appleColors: AppleColorsLightValues,
    backgroundColors: BackgroundColorsLightValues,
    controlBackgroundColors: ControlBackgroundColorsLightValues,
    controlBorderColors: ControlBorderColorsLightValues,
    controlCaretColors: ControlCaretColorsLightValues,
    controlEndIconColors: ControlEndIconColorsLightValues,
    controlPlaceholderColors: ControlPlaceholderColorsLightValues,
    controlSliderThumbColors: ControlSliderThumbColorsLightValues,
    controlSliderTrackColors: ControlSliderTrackColorsLightValues,
    controlStartIconColors: ControlStartIconColorsLightValues,
    controlTextColors: ControlTextColorsLightValues,
    controlValueColors: ControlValueColorsLightValues,
    errorColors: ErrorColorsLightValues,
    facebookColors: FacebookColorsLightValues,
    googleColors: GoogleColorsLightValues,
    informationColors: InformationColorsLightValues,
    kakaoColors: KakaoColorsLightValues,
    lineColors: LineColorsLightValues,
    negativeColors: NegativeColorsLightValues,
    positiveColors: PositiveColorsLightValues,
    premiumColors: PremiumColorsLightValues,
    primaryColors: PrimaryColorsLightValues,
    secondaryColors: SecondaryColorsLightValues,
    snapchatColors: SnapchatColorsLightValues,
    successColors: SuccessColorsLightValues,
    textColors: TextColorsLightValues,
    transformerColors: TransformerColorsLightValues,
    warningColors: WarningColorsLightValues,
    neutralColors: NeutralColorsLightValues,
    shadows: ShadowLightValues,
    gradients: GradientsValues,
});
const ThemeDarkValues = Object.freeze({
    absolutesBlackColors: AbsolutesBlackColorsDarkValues,
    absolutesWhiteColors: AbsolutesWhiteColorsDarkValues,
    appleColors: AppleColorsDarkValues,
    backgroundColors: BackgroundColorsDarkValues,
    controlBackgroundColors: ControlBackgroundColorsDarkValues,
    controlBorderColors: ControlBorderColorsDarkValues,
    controlCaretColors: ControlCaretColorsDarkValues,
    controlEndIconColors: ControlEndIconColorsDarkValues,
    controlPlaceholderColors: ControlPlaceholderColorsDarkValues,
    controlSliderThumbColors: ControlSliderThumbColorsDarkValues,
    controlSliderTrackColors: ControlSliderTrackColorsDarkValues,
    controlStartIconColors: ControlStartIconColorsDarkValues,
    controlTextColors: ControlTextColorsDarkValues,
    controlValueColors: ControlValueColorsDarkValues,
    errorColors: ErrorColorsDarkValues,
    facebookColors: FacebookColorsDarkValues,
    googleColors: GoogleColorsDarkValues,
    informationColors: InformationColorsDarkValues,
    kakaoColors: KakaoColorsDarkValues,
    lineColors: LineColorsDarkValues,
    negativeColors: NegativeColorsDarkValues,
    positiveColors: PositiveColorsDarkValues,
    premiumColors: PremiumColorsDarkValues,
    primaryColors: PrimaryColorsDarkValues,
    secondaryColors: SecondaryColorsDarkValues,
    snapchatColors: SnapchatColorsDarkValues,
    successColors: SuccessColorsDarkValues,
    textColors: TextColorsDarkValues,
    transformerColors: TransformerColorsDarkValues,
    warningColors: WarningColorsDarkValues,
    neutralColors: NeutralColorsDarkValues,
    shadows: ShadowDarkValues,
    gradients: GradientsValues,
});
function generateTheme(theme) {
    return Object.freeze({
        // Absolutes Black Start
        '--absolute-black-base-default': theme.absolutesBlackColors.base.default,
        '--absolute-black-base-action': theme.absolutesBlackColors.base.action,
        '--absolute-black-base-active': theme.absolutesBlackColors.base.active,
        '--absolute-black-base-active-action': theme.absolutesBlackColors.base.activeAction,
        '--absolute-black-text-default': theme.absolutesBlackColors.text.default,
        '--absolute-black-text-action': theme.absolutesBlackColors.text.action,
        '--absolute-black-text-active': theme.absolutesBlackColors.text.action,
        '--absolute-black-text-active-action': theme.absolutesBlackColors.text.activeAction,
        // Absolutes Black End
        // Absolutes White Start
        '--absolute-white-base-default': theme.absolutesWhiteColors.base.default,
        '--absolute-white-base-action': theme.absolutesWhiteColors.base.action,
        '--absolute-white-base-active': theme.absolutesWhiteColors.base.active,
        '--absolute-white-base-active-action': theme.absolutesWhiteColors.base.activeAction,
        '--absolute-white-text-default': theme.absolutesWhiteColors.text.default,
        '--absolute-white-text-action': theme.absolutesWhiteColors.text.action,
        '--absolute-white-text-active': theme.absolutesWhiteColors.text.action,
        '--absolute-white-text-active-action': theme.absolutesWhiteColors.text.activeAction,
        // Absolutes White End
        // Apple White Start
        '--apple-base-default': theme.appleColors.base.default,
        '--apple-base-action': theme.appleColors.base.action,
        '--apple-base-active': theme.appleColors.base.active,
        '--apple-base-active-action': theme.appleColors.base.activeAction,
        '--apple-text-default': theme.appleColors.text.default,
        '--apple-text-action': theme.appleColors.text.action,
        '--apple-text-active': theme.appleColors.text.action,
        '--apple-text-active-action': theme.appleColors.text.activeAction,
        // Apple White End
        // Backgrounds Start
        '--backgrounds-base': theme.backgroundColors.base,
        '--backgrounds-tint-1': theme.backgroundColors.tint1,
        '--backgrounds-tint-2': theme.backgroundColors.tint2,
        '--backgrounds-tint-3': theme.backgroundColors.tint3,
        '--backgrounds-border': theme.backgroundColors.border,
        '--backgrounds-tooltip': theme.backgroundColors.tooltip,
        '--backgrounds-popover': theme.backgroundColors.popover,
        '--backgrounds-transparent': theme.backgroundColors.transparent,
        '--backgrounds-gradient-up': theme.backgroundColors.gradientUp,
        '--backgrounds-gradient-down': theme.backgroundColors.gradientDown,
        '--backgrounds-gradient-left': theme.backgroundColors.gradientLeft,
        '--backgrounds-gradient-right': theme.backgroundColors.gradientRight,
        '--backgrounds-canvas-back-layer': theme.backgroundColors.canvasBackLayer,
        '--backgrounds-negative-transparent': theme.backgroundColors.negativeTransparent,
        // Backgrounds End
        // Control Background Start
        '--controls-background-default': theme.controlBackgroundColors.default,
        '--controls-background-action': theme.controlBackgroundColors.action,
        '--controls-background-active': theme.controlBackgroundColors.active,
        '--controls-background-active-action': theme.controlBackgroundColors.activeAction,
        // Control Background End
        // Control Border Start
        '--controls-border-default': theme.controlBorderColors.default,
        '--controls-border-action': theme.controlBorderColors.action,
        '--controls-border-active': theme.controlBorderColors.active,
        '--controls-border-active-action': theme.controlBorderColors.activeAction,
        // Control Border End
        // Control Caret Start
        '--controls-caret-default': theme.controlCaretColors.default,
        '--controls-caret-action': theme.controlCaretColors.action,
        '--controls-caret-active': theme.controlCaretColors.active,
        '--controls-caret-active-action': theme.controlCaretColors.activeAction,
        // Control Caret End
        // Control EndIcon Start
        '--controls-end-icon-default': theme.controlEndIconColors.default,
        '--controls-end-icon-action': theme.controlEndIconColors.action,
        '--controls-end-icon-active': theme.controlEndIconColors.active,
        '--controls-end-icon-active-action': theme.controlEndIconColors.activeAction,
        // Control EndIcon End
        // Control Placeholder Start
        '--controls-placeholder-default': theme.controlPlaceholderColors.default,
        '--controls-placeholder-action': theme.controlPlaceholderColors.action,
        '--controls-placeholder-active': theme.controlPlaceholderColors.active,
        '--controls-placeholder-active-action': theme.controlPlaceholderColors.activeAction,
        // Control Placeholder End
        // Control SliderThumb Start
        '--controls-slider-thumb-default': theme.controlSliderThumbColors.default,
        '--controls-slider-thumb-action': theme.controlSliderThumbColors.action,
        '--controls-slider-thumb-active': theme.controlSliderThumbColors.active,
        '--controls-slider-thumb-active-action': theme.controlSliderThumbColors.activeAction,
        // Control SliderThumb End
        // Control SliderTrack Start
        '--controls-slider-track-default': theme.controlSliderTrackColors.default,
        '--controls-slider-track-action': theme.controlSliderTrackColors.action,
        '--controls-slider-track-active': theme.controlSliderTrackColors.active,
        '--controls-slider-track-active-action': theme.controlSliderTrackColors.activeAction,
        // Control SliderTrack End
        // Control StartIcon Start
        '--controls-start-icon-default': theme.controlStartIconColors.default,
        '--controls-start-icon-action': theme.controlStartIconColors.action,
        '--controls-start-icon-active': theme.controlStartIconColors.active,
        '--controls-start-icon-active-action': theme.controlStartIconColors.activeAction,
        // Control StartIcon End
        // Control Text Start
        '--controls-text-default': theme.controlTextColors.default,
        '--controls-text-action': theme.controlTextColors.action,
        '--controls-text-active': theme.controlTextColors.active,
        '--controls-text-active-action': theme.controlTextColors.activeAction,
        // Control Text End
        // Control Value Start
        '--controls-value-default': theme.controlValueColors.default,
        '--controls-value-action': theme.controlValueColors.action,
        '--controls-value-active': theme.controlValueColors.active,
        '--controls-value-active-action': theme.controlValueColors.activeAction,
        // Control Value End
        // Error Start
        '--error-base-default': theme.errorColors.base.default,
        '--error-base-action': theme.errorColors.base.action,
        '--error-base-active': theme.errorColors.base.active,
        '--error-base-active-action': theme.errorColors.base.activeAction,
        '--error-text-default': theme.errorColors.text.default,
        '--error-text-action': theme.errorColors.text.action,
        '--error-text-active': theme.errorColors.text.active,
        '--error-text-active-action': theme.errorColors.text.activeAction,
        // Error End
        // Facebook Start
        '--facebook-base-default': theme.facebookColors.base.default,
        '--facebook-base-action': theme.facebookColors.base.action,
        '--facebook-base-active': theme.facebookColors.base.active,
        '--facebook-base-active-action': theme.facebookColors.base.activeAction,
        '--facebook-text-default': theme.facebookColors.text.default,
        '--facebook-text-action': theme.facebookColors.text.action,
        '--facebook-text-active': theme.facebookColors.text.active,
        '--facebook-text-active-action': theme.facebookColors.text.activeAction,
        // Facebook End
        // Google Start
        '--google-base-default': theme.googleColors.base.default,
        '--google-base-action': theme.googleColors.base.action,
        '--google-base-active': theme.googleColors.base.active,
        '--google-base-active-action': theme.googleColors.base.activeAction,
        '--google-text-default': theme.googleColors.text.default,
        '--google-text-action': theme.googleColors.text.action,
        '--google-text-active': theme.googleColors.text.active,
        '--google-text-active-action': theme.googleColors.text.activeAction,
        // Google End
        // Information Start
        '--information-base-default': theme.informationColors.base.default,
        '--information-base-action': theme.informationColors.base.action,
        '--information-base-active': theme.informationColors.base.active,
        '--information-base-active-action': theme.informationColors.base.activeAction,
        '--information-text-default': theme.informationColors.text.default,
        '--information-text-action': theme.informationColors.text.action,
        '--information-text-active': theme.informationColors.text.active,
        '--information-text-active-action': theme.informationColors.text.activeAction,
        // Information End
        // Kakao Start
        '--kakao-base-default': theme.kakaoColors.base.default,
        '--kakao-base-action': theme.kakaoColors.base.action,
        '--kakao-base-active': theme.kakaoColors.base.active,
        '--kakao-base-active-action': theme.kakaoColors.base.activeAction,
        '--kakao-text-default': theme.kakaoColors.text.default,
        '--kakao-text-action': theme.kakaoColors.text.action,
        '--kakao-text-active': theme.kakaoColors.text.active,
        '--kakao-text-active-action': theme.kakaoColors.text.activeAction,
        // Kakao End
        // Line Start
        '--line-base-default': theme.lineColors.base.default,
        '--line-base-action': theme.lineColors.base.action,
        '--line-base-active': theme.lineColors.base.active,
        '--line-base-active-action': theme.lineColors.base.activeAction,
        '--line-text-default': theme.lineColors.text.default,
        '--line-text-action': theme.lineColors.text.action,
        '--line-text-active': theme.lineColors.text.active,
        '--line-text-active-action': theme.lineColors.text.activeAction,
        // Line End
        // Negative Start
        '--negative-base-default': theme.negativeColors.base.default,
        '--negative-base-action': theme.negativeColors.base.action,
        '--negative-base-active': theme.negativeColors.base.active,
        '--negative-base-active-action': theme.negativeColors.base.activeAction,
        '--negative-text-default': theme.negativeColors.text.default,
        '--negative-text-action': theme.negativeColors.text.action,
        '--negative-text-active': theme.negativeColors.text.active,
        '--negative-text-active-action': theme.negativeColors.text.activeAction,
        // Negative End
        // Positive Start
        '--positive-base-default': theme.positiveColors.base.default,
        '--positive-base-action': theme.positiveColors.base.action,
        '--positive-base-active': theme.positiveColors.base.active,
        '--positive-base-active-action': theme.positiveColors.base.activeAction,
        '--positive-text-default': theme.positiveColors.text.default,
        '--positive-text-action': theme.positiveColors.text.action,
        '--positive-text-active': theme.positiveColors.text.active,
        '--positive-text-active-action': theme.positiveColors.text.activeAction,
        // Positive End
        // Premium Start
        '--premium-base-default': theme.premiumColors.base.default,
        '--premium-base-action': theme.premiumColors.base.action,
        '--premium-base-active': theme.premiumColors.base.active,
        '--premium-base-active-action': theme.premiumColors.base.activeAction,
        '--premium-text-default': theme.premiumColors.text.default,
        '--premium-text-action': theme.premiumColors.text.action,
        '--premium-text-active': theme.premiumColors.text.active,
        '--premium-text-active-action': theme.premiumColors.text.activeAction,
        // Premium End
        // Primary Start
        '--primary-base-default': theme.primaryColors.base.default,
        '--primary-base-action': theme.primaryColors.base.action,
        '--primary-base-active': theme.primaryColors.base.active,
        '--primary-base-active-action': theme.primaryColors.base.activeAction,
        '--primary-text-default': theme.primaryColors.text.default,
        '--primary-text-action': theme.primaryColors.text.action,
        '--primary-text-active': theme.primaryColors.text.active,
        '--primary-text-active-action': theme.primaryColors.text.activeAction,
        '--primary-alpha-20': theme.primaryColors.alpha.alpha20,
        '--primary-alpha-50': theme.primaryColors.alpha.alpha50,
        '--primary-alpha-80': theme.primaryColors.alpha.alpha80,
        // Primary End
        // Secondary Start
        '--secondary-base-default': theme.secondaryColors.base.default,
        '--secondary-base-action': theme.secondaryColors.base.action,
        '--secondary-base-active': theme.secondaryColors.base.active,
        '--secondary-base-active-action': theme.secondaryColors.base.activeAction,
        '--secondary-text-default': theme.secondaryColors.text.default,
        '--secondary-text-action': theme.secondaryColors.text.action,
        '--secondary-text-active': theme.secondaryColors.text.active,
        '--secondary-text-active-action': theme.secondaryColors.text.activeAction,
        '--secondary-alpha-20': theme.secondaryColors.alpha.alpha20,
        '--secondary-alpha-50': theme.secondaryColors.alpha.alpha50,
        '--secondary-alpha-80': theme.secondaryColors.alpha.alpha80,
        // Secondary End
        // Snapchat Start
        '--snapchat-base-default': theme.snapchatColors.base.default,
        '--snapchat-base-action': theme.snapchatColors.base.action,
        '--snapchat-base-active': theme.snapchatColors.base.active,
        '--snapchat-base-active-action': theme.snapchatColors.base.activeAction,
        '--snapchat-text-default': theme.snapchatColors.text.default,
        '--snapchat-text-action': theme.snapchatColors.text.action,
        '--snapchat-text-active': theme.snapchatColors.text.active,
        '--snapchat-text-active-action': theme.snapchatColors.text.activeAction,
        // Snapchat End
        // Success Start
        '--success-base-default': theme.successColors.base.default,
        '--success-base-action': theme.successColors.base.action,
        '--success-base-active': theme.successColors.base.active,
        '--success-base-active-action': theme.successColors.base.activeAction,
        '--success-text-default': theme.successColors.text.default,
        '--success-text-action': theme.successColors.text.action,
        '--success-text-active': theme.successColors.text.active,
        '--success-text-active-action': theme.successColors.text.activeAction,
        // Success End
        // Text Start
        '--texts-base': theme.textColors.base,
        '--texts-tint-1': theme.textColors.tint1,
        '--texts-tint-2': theme.textColors.tint2,
        '--texts-tint-3': theme.textColors.tint3,
        // Text End
        // Transformer Start
        '--transformer-base-default': theme.transformerColors.base.default,
        '--transformer-base-action': theme.transformerColors.base.action,
        '--transformer-base-active': theme.transformerColors.base.active,
        '--transformer-base-active-action': theme.transformerColors.base.activeAction,
        '--transformer-text-default': theme.transformerColors.text.default,
        '--transformer-text-action': theme.transformerColors.text.action,
        '--transformer-text-active': theme.transformerColors.text.active,
        '--transformer-text-active-action': theme.transformerColors.text.activeAction,
        // Transformer End
        // Warning Start
        '--warning-base-default': theme.warningColors.base.default,
        '--warning-base-action': theme.warningColors.base.action,
        '--warning-base-active': theme.warningColors.base.active,
        '--warning-base-active-action': theme.warningColors.base.activeAction,
        '--warning-text-default': theme.warningColors.text.default,
        '--warning-text-action': theme.warningColors.text.action,
        '--warning-text-active': theme.warningColors.text.active,
        '--warning-text-active-action': theme.warningColors.text.activeAction,
        // Warning End
        // Neutral Start
        '--neutral-base-default': theme.neutralColors.base.default,
        '--neutral-base-action': theme.neutralColors.base.action,
        '--neutral-base-active': theme.neutralColors.base.active,
        '--neutral-base-active-action': theme.neutralColors.base.activeAction,
        '--neutral-text-default': theme.neutralColors.text.default,
        '--neutral-text-action': theme.neutralColors.text.action,
        '--neutral-text-active': theme.neutralColors.text.active,
        '--neutral-text-active-action': theme.neutralColors.text.activeAction,
        // Neutral End
        // Shadows Start
        '--shadows-tint-1': theme.shadows.tint1,
        '--shadows-tint-2': theme.shadows.tint2,
        '--shadows-tint-3': theme.shadows.tint3,
        // Shadows End
        // Gradients Start
        '--gradient-primary': theme.gradients.primary,
        '--gradient-gold': theme.gradients.gold,
        '--gradient-plus': theme.gradients.plus,
        '--gradient-pro': theme.gradients.pro,
        '--gradient-eggsellent': theme.gradients.eggsellent,
        '--gradient-lotus': theme.gradients.lotus,
        '--gradient-aura': theme.gradients.aura,
        '--gradient-tangerine': theme.gradients.tangerine,
        '--gradient-valentine': theme.gradients.valentine,
        '--gradient-dusk': theme.gradients.dusk,
        '--gradient-desert': theme.gradients.desert,
        '--gradient-sunrise': theme.gradients.sunrise,
        '--gradient-sandyStorm': theme.gradients.sandyStorm,
        '--gradient-venus': theme.gradients.venus,
        '--gradient-sahara': theme.gradients.sahara,
        '--gradient-alien': theme.gradients.alien,
        '--gradient-midnight': theme.gradients.midnight,
        '--gradient-userPlus': theme.gradients.userPlus,
        '--gradient-userPro': theme.gradients.userPro,
        '--gradient-performance': theme.gradients.performance,
        '--gradient-essentials': theme.gradients.essentials,
        // Gradients End
    });
}

export { ThemeDarkValues, ThemeLightValues, generateTheme };
